<template src="./card.html"></template>
<style lang="less" scoped src="./card.less"></style>

<script>
    export default {
        props: {
            customClass: String
        },
        methods: {
            click(ev) {
                this.$emit('click', ev)
            }
        }
    }
</script>